import { Component, OnInit, ChangeDetectorRef, Renderer2, RendererFactory2, inject, ChangeDetectionStrategy } from '@angular/core';

import { HTTPStatus } from '../loader/his-httplistener.service';

@Component( {
    selector: 'his-httplistener',
    templateUrl: './his-httplistener.component.html',
    styleUrls: ['./his-httplistener.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisHttplistenerComponent implements OnInit {
    private httpStatus = inject(HTTPStatus);
    private rendererFactory = inject(RendererFactory2);
    private changeDetectorRef = inject(ChangeDetectorRef);


    loading = false;
    private renderer: Renderer2;

    constructor() {
        this.renderer = this.rendererFactory.createRenderer( null, null );
    }

    ngOnInit() {
        this.httpStatus.getHttpStatus().subscribe( ( loading: boolean ) => {
            this.loading = loading;
            if ( loading ) {
                this.renderer.setStyle( document.body, 'cursor', 'wait' );
            } else {
                this.renderer.setStyle( document.body, 'cursor', 'default' );
            }
            this.changeDetectorRef.detectChanges();
        } );
    }

}
